import { Link } from "react-router";
import { useIncidentRows } from "../api/client";
import { ErrorBanner } from "../components/ui";
import { WidePanel } from "../components/Workspace";
import { IncidentTable } from "./reports/tables";

// Every incident raised here, newest first, with the links to its Slack channel and Jira ticket. Open to all staff, like the reports.
export function IncidentList() {
  const query = useIncidentRows();
  return (
    <WidePanel>
      <div className="phase-head">
        <h1>All incidents</h1>
        <p>
          Every incident raised in Triage Desk, with a link to its Slack channel and its Jira ticket. Open an incident to follow it up if you are its owner, backup owner or an admin.{" "}
          <Link to="/new/incident">Report an incident</Link>
        </p>
      </div>
      {query.isPending && <p className="record-note">Loading…</p>}
      {query.isError && <ErrorBanner>We couldn't load the incidents.</ErrorBanner>}
      {query.data && <IncidentTable rows={query.data} />}
    </WidePanel>
  );
}
